
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from './signUpForm.module.css';
import { FcGoogle } from "react-icons/fc";
import { useNavigate } from 'react-router-dom';

import { useGoogleLogin } from '@react-oauth/google';


import toast from 'react-hot-toast';
import { axiosInstance } from "../../../lib/axiosInstance";

function SignUpForm() {

  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [nameMessage, setNameMessage] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [lengthMessage, setLengthMessage] = useState("");

  const [contact, setContact] = useState({
    name: "",   //username
    email: "",
    password: ""
  });

  function handleChange(event) {
    //console.log(event.target); //When printed it will print the html tag which triggered the event.
    //In React, event.target is a synthetic representation of the actual DOM element and is wrapped in a synthetic event object.
    //Although it appears as an HTML-like string when printed, it is still an object with various properties and methods.
    //When you destructure const { value, name } = event.target;, it extracts the value and name properties from that synthetic event target object, enabling you to conveniently access the values of the corresponding input element's value and name attributes.
    //I think when the console.log statement is used to print the "event.target" object, react detects it and displays it as the html element which triggered the event using the synthetic event wrapper object.

    const { value, name } = event.target;
    //console.log(value, name);          // Name of the element and the value of the element.

    // Using spread operator made it short.
    setContact((prevValue) => {
      return {
        ...prevValue,
        [name]: value
      };
    });
  }

  async function handleFormSubmit(event) {
    event.preventDefault();   //To prevent the page from refreshing.

    // Check if password length is atleast 6.
    if (contact.password.length < 6){
      setLengthMessage("New password must be atleast 6 characters.");
      return;
    }

    if (contact.password.length > 6){
      setLengthMessage("");
    }
    

    try {
      // Make a POST request to your server
      
      const response = await axiosInstance.post('/auth/signup', contact); 

      toast.success("An email has been sent to your mail for verification. Please verify", {duration: 10000});

      //const response = await axiosInstance.post('/auth/signup', contact, { withCredentials: true });   
      // "axios" is a popular JavaScript library used for making HTTP requests from web browsers or Node.js applications. 
      // It simplifies the process of sending asynchronous HTTP requests to servers and handling responses.
      
      // Handle the response as needed.
      //console.log('SignUp Server response:', response.data);
      //Add here the redirect to /signin code if the success (response.data.success) field is true in the response.
      
      /*
      if (response.data.redirectToSignIn === true){    //I am suspicious if we need to give "response.data.success === true" because the key "success" is there for error response as well.
        navigate('/signin'); // Redirects to the "/signin" route
      }*/
      navigate('/signin'); // Redirects to the "/signin" route
      
    } catch (error) {
      // Handle errors
      //console.error('Error:', error.message);
      setErrorMessage(
                        (Array.isArray(error.response?.data?.message)? error.response?.data?.message[0] : error.response?.data?.message) 
                        || 
                        "An error occurred!"
                      );


      //-----------------
      if (error.response) {
        // Server responded with a status other than 200 range
        console.log("Error Data: ", error.response.data);
        console.log("Error Status: ", error.response.status);
        console.log("Error Headers: ", error.response.headers);
      } else if (error.request) {
        // Request was made but no response was received
        console.log("Error Request: ", error.request);
      } else {
        // Something else happened
        console.log("Error Message: ", error.message);
      }
    }
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: async tokenResponse => {
      console.log("tokenResponse : ",tokenResponse);
      await axiosInstance.post('/auth/login/google', {jwt : tokenResponse.access_token});
  }});
  
  
  return (
    <div className={styles.inner_container}>
      <h1 className={styles.welcome_title}>
        Welcome to <span className= {styles.discuss}>Discuss</span><span>learn!</span>
      </h1>
      {/* <h2>
        Let's get you signed up.
      </h2> */}
      <form onSubmit={handleFormSubmit}>
        <input
          onChange={handleChange}
          value={contact.name}   //contact.username
          name="name"   //username
          placeholder="Your name"
          className={styles.input}
          required
        />
        {nameMessage && <p style={{ color: "red" }}>Name should be given.</p>}
        <input
          onChange={handleChange}
          value={contact.email}
          name="email"
          type="email"
          placeholder="Email"
          className={styles.input}
          required
        />
        {emailMessage && <p style={{ color: "red" }}>Email is taken.</p>}
        <input
          onChange={handleChange}
          value={contact.password}
          name="password"
          type="password"
          placeholder="Password"
          className={styles.input}
          required
        />
        {lengthMessage && <p style={{ color: "red" }}>Password must be atleast 6 characters long.</p>}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        <button className={styles.signup_button} type="submit">Sign Up</button>
      </form>
      <div className={styles.hr_div}>
        <hr className={styles.hr}></hr>
        <p className={styles.or}>or</p>
        <hr className={styles.hr}></hr>
      </div>
      
      <button onClick={() => loginWithGoogle()} className={styles.google_button}>
        <FcGoogle className={styles.google_icon}/>
        <span>Sign Up with Google</span>
      </button>
    

      <div className={styles.already_account_div}>
        <p className={styles.already_account_p_tag}>Already have an account?</p>
        <Link className={styles.link} to="/signin"><span>Sign in</span></Link>
      </div>
    </div>
  );
}

export default SignUpForm;
